import React from "react";

/**
 * @file TimeFilter.js
 * @description Reusable time selection component with presets (Daily, Weekly, etc.) and custom range support.
 */
export default function TimeFilter({ value, onChange, onCustomRangeChange, startDate, endDate }) {
  const isCustom = value === "custom";
  const today = new Date().toISOString().split('T')[0];

  return (
    <div className="d-flex align-items-center gap-2">
      <select
        className="form-select form-select-sm shadow-sm border-secondary-subtle"
        style={{ width: "140px", fontWeight: "500" }}
        value={value}
        onChange={(e) => {
          const val = e.target.value;
          if (val === "custom" && onCustomRangeChange) {
            onCustomRangeChange("start", "");
            onCustomRangeChange("end", "");
          }
          onChange(val);
        }}
      >
        <option value="daily">Last 24 Hours</option>
        <option value="weekly">Weekly</option>
        <option value="monthly">Monthly</option>
        <option value="quarterly">Quarterly</option>
        <option value="annual">Annual</option>
        <option value="all_time">All Time</option>
        <option value="custom">Custom Range</option>
      </select>

      {isCustom && (
        <div className="d-flex align-items-center gap-2">
          <input
            type="date"
            className="form-control form-control-sm shadow-sm"
            value={startDate || ""}
            max={endDate || today}
            onChange={(e) => onCustomRangeChange && onCustomRangeChange("start", e.target.value)}
            style={{ width: "130px" }}
          />
          <span className="text-muted fw-bold small">to</span>
          <input
            type="date"
            className="form-control form-control-sm shadow-sm"
            value={endDate || ""}
            min={startDate}
            max={today}
            onChange={(e) => onCustomRangeChange && onCustomRangeChange("end", e.target.value)}
            style={{ width: "130px" }}
          />
        </div>
      )}
    </div>
  );
}
